import * as THREE from 'three';

export const ScanlineShader = {
  name: 'ScanlineShader',

  uniforms: {
    tDiffuse: { value: null as THREE.Texture | null },
    resolution: { value: new THREE.Vector2(1, 1) },
    scanlineOpacity: { value: 0.12 },
    scanlineCount: { value: 400.0 },
    curvature: { value: 0.03 },
    vignetteStrength: { value: 0.35 },
    phosphorTint: { value: 0.0 },
    time: { value: 0.0 },
  },

  vertexShader: /* glsl */ `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,

  fragmentShader: /* glsl */ `
    uniform sampler2D tDiffuse;
    uniform vec2 resolution;
    uniform float scanlineOpacity;
    uniform float scanlineCount;
    uniform float curvature;
    uniform float vignetteStrength;
    uniform float phosphorTint;
    uniform float time;

    varying vec2 vUv;

    vec2 barrelDistortion(vec2 uv) {
      vec2 centered = uv * 2.0 - 1.0;
      float r2 = dot(centered, centered);
      centered *= 1.0 + curvature * r2 + curvature * 0.5 * r2 * r2;
      return centered * 0.5 + 0.5;
    }

    void main() {
      vec2 uv = barrelDistortion(vUv);

      if (uv.x < 0.0 || uv.x > 1.0 || uv.y < 0.0 || uv.y > 1.0) {
        gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);
        return;
      }

      vec4 color = texture2D(tDiffuse, uv);

      // Horizontal scanlines
      float scanline = sin(uv.y * scanlineCount * 3.14159) * 0.5 + 0.5;
      scanline = pow(scanline, 1.8);
      color.rgb *= 1.0 - scanlineOpacity * (1.0 - scanline);

      // Subtle flicker
      float flicker = 1.0 - 0.01 * sin(time * 8.0);
      color.rgb *= flicker;

      // Vignette
      vec2 vigUv = vUv * 2.0 - 1.0;
      float vignette = 1.0 - dot(vigUv, vigUv) * vignetteStrength;
      vignette = clamp(vignette, 0.0, 1.0);
      color.rgb *= vignette;

      // Phosphor green tint
      if (phosphorTint > 0.0) {
        float luminance = dot(color.rgb, vec3(0.299, 0.587, 0.114));
        vec3 greenPhosphor = vec3(luminance * 0.2, luminance, luminance * 0.3);
        color.rgb = mix(color.rgb, greenPhosphor, phosphorTint);
      }

      gl_FragColor = color;
    }
  `,
};
